import type { ReactNode } from 'react';

export const symbol_buttons_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-240q-24 0-42-18t-18-42v-360q0-24 18-42t42-18h680q24 0 42 18t18 42v360q0 24-18 42t-42 18H140Zm0-60h680v-360H140v360Zm147-155v71q0 10.4 7.12 17.2 7.11 6.8 18 6.8 10.88 0 17.38-7.08 6.5-7.09 6.5-17.92v-70h70q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7h-70v-71q0-10.4-6.5-17.2-6.5-6.8-17.38-6.8-10.89 0-18 6.5Q287-587 287-576v71h-70q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h70ZM140-300v-360 360Z"
		/>
	</svg>
);
